export class HttpError extends Error {
  constructor(
    private _statusCode: number,
    private _statusText: string,
    private _body?: string
  ) {
    super();
  }
  get statusText(): string {
    return this._statusText;
  }
  get statusCode(): number {
    return this._statusCode;
  }
  get body(): string {
    return this._body || "";
  }
}
